export function isDailyRateClosed(rate): boolean {
    return !!rate && !rate.placeholder && rate.active === false
}

export function areAllTariffsClosed(tariffs, date: string): boolean {
    if (!tariffs?.length) return false
    return tariffs.every(tariff => {
        const tariffDay = tariff.dailyRates.find(day => day.date === date)
        return isDailyRateClosed(tariffDay?.rate)
    })
}
